module.exports = __webpack_public_path__ + "static/media/blue-heron-pointe.bc14d59d.pdf";